import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Card, Row, Col, Form, Offcanvas } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import moment from 'moment';
import { currencyConverter } from "../../utils";
import {ReactComponent as FilterSvg} from './../../assets/icons/svg/filter.svg';
import {ReactComponent as CheckSvg} from './../../assets/icons/svg/check.svg';
import ListTransaction from "../../components/ListTransaction";
import dayjs from "dayjs";
import { toast } from "react-toastify";

export default function MutationHistory() {
   const navigate = useNavigate();
   const [trnc, setTrnc] = useState([]);
   const { id } = useParams();
   const [filter, setFilter] = useState({
      limit:"name",
      filter:"name"
   });
   const [keyword, setKeyword] = useState('');
   const [trFilter, setTrFilter] = useState('all');
   const [showConfirm, setShowConfirm] = useState(false);
   const handleCloseConfirm = () => setShowConfirm(false);
   const handleShowConfirm = () => setShowConfirm(true);
   const limit_list = [
      {name:'Semua', path: 'name'},
      {name:'Terbaru', path: '-created_at'},
      {name:'Paling Lama', path: 'created_at'},
    ]
    const filter_list = [
      {name:'Semua', path: 'name'},
      {name:'Setor', path: 'credit'},
      {name:'Tarik', path: 'debit'},
      {name:'Biaya', path: 'balance'},
    ]
    const [loading, setLoading] = useState(true);
    const [load, setLoad] = useState(false);
  
  useEffect(() => {
    transaction.actions.get_transaction_history(id, '-created_at', filter.filter, keyword).then((res)=>{
      setTrnc(res?.transaction?.data)
      setLoading(false)
    });
  },[])
  
  const getTransaction = (pr, key) => {
      setTrFilter(pr);
      setKeyword(key);
      setLoading(true);
      handleCloseConfirm();
      if(pr === 'all'){
      setFilter({limit:'name', filter: 'name'});
        transaction.actions.get_transaction_history(id, '-created_at', filter.filter, key).then((res)=>{
          setTrnc(res?.transaction?.data);
          setLoading(false);
        });
      } else {
        transaction.actions.get_transaction_history(id, (filter.limit === 'name' ? '-created_at' : filter.limit), filter.filter, key).then((res)=>{
          setTrnc(res?.transaction?.data);
          setLoading(false);
        });
      }
   }

   const onDownload = () => {
    setLoad(true);
    transaction.actions.get_transaction_download(id).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      setLoad(false);
      toast.success('Sukses mengunduh mutasi')
    }).catch((err)=>{
      setLoad(false);
      toast.error('Gagal mengunduh mutasi')
    })
   }
  
   return (
   <div className="bg-gray vh-100">
      <div className="fixed-top header bg-gray">
         <div className="text-center fw-semibold">
            Riwayat Transaksi
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>
      
      <div className="p-4 mt-5 pt-5">
         <div className="mt-4 content-height">
            <div className="d-flex align-items-center justify-content-between">
               <Form.Control placeholder="Cari transaksi" className="me-3" onChange={(e) => getTransaction(trFilter, e.target.value)}/>
               <div onClick={() => handleShowConfirm()}><FilterSvg/></div>
            </div>
            <div className="fw-semibold text-muted mt-4">Riwayat Transaksi</div>
            {loading?
            <div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
              <div className="skeleton skeleton-list mb-3"></div>
            </div>:
            ( trnc.length > 0 ?
              <>
                {trnc && trnc.length && trnc.map((item, key) => {
                  return (<div onClick={() => navigate(`/mutation/${id}/history/${item?.id}`)} key={key}><ListTransaction data={item}/></div>)
                })}
              </> : 
              <div className="text-secondary text-center p-3 ts-sm">
                Tidak ada list transaksi
              </div>
            )
          }
         </div>
      </div>

      <div className="d-grid gap-2 fixed-bottom p-4">
         <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => onDownload()}>
            {load ? <i className="ph-spinner spinner text-light"></i> : 'UNDUH DATA MUTASI'}
         </Button>
      </div>

      <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filter</Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-4">

          <div className="listing mb-3">
            <div className="text-secondary mb-3">Data Riwayat</div>
            <div className="d-flex align-items-center">
              {limit_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.limit ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{limit: data.path}})}
                >
                  {data.name}
                  {data.path === filter.limit ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="listing mb-4">
            <div className="text-secondary mb-3">Jenis Transaksi</div>
            <div className="d-flex align-items-center">
              {filter_list.map((data,key)=>{
                return ( 
                <div className={'d-flex align-items-center py-2 px-3 me-2 rounded-pill' + (data.path === filter.filter ? ' btn-success text-white' : ' bg-gray')} 
                  key={key}
                  onClick={() => setFilter({...filter, ...{filter: data.path}})}
                >
                  {data.name}
                  {data.path === filter.filter ?
                    <CheckSvg className="ms-1"/> : null
                  }
                </div>
                )
              })}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center w-100">
              <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => getTransaction('all', keyword)}>
                Atur Ulang
              </Button>
              <Button onClick={() => getTransaction('custom', keyword)} className="rounded-pill py-2 w-50" variant="success">
                Terapkan
              </Button>
          </div>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}